import { useRouter } from '@fabric-app/compat';
import { useMemo } from 'react';
import { AssistantEphemeralContextType, AssistantEphemeralContextSubType } from '../types.js';
import { EVERYTHING_CONTEXT } from '../constants.js';
import { useQueryInbox } from '../../connections/queries/useQueryInbox.js';
import { getRouteParamAsString } from '@fabric-app/utils/url/routing';
import { useQuerySpaceOrFolderById } from '../../resources/queries/useQuerySpaceOrFolderById.js';
import { useExpandedResource } from '../../resources/stores/useExpandedResourceStore.js';

const useContextFinder = (resourceId) => {
  const router = useRouter();
  const expandedResourceId = useExpandedResource();
  const [folderId, spaceIdFromRoute] = getRouteParamAsString(router.query, [
    "folderId",
    "listId"
  ]);
  const { inboxRoot } = useQueryInbox();
  const isInbox = router.pathname === "/saved";
  const spaceOrFolder = useQuerySpaceOrFolderById(folderId || spaceIdFromRoute);
  const contextOptions = useMemo(() => {
    const options = [
      EVERYTHING_CONTEXT
    ];
    if (isInbox && inboxRoot) {
      options.push({
        name: "Inbox",
        subType: AssistantEphemeralContextSubType.Space,
        value: inboxRoot.id,
        type: AssistantEphemeralContextType.Ancestor
      });
    }
    if (spaceOrFolder) {
      if (spaceOrFolder.type === "space" && [
        "SPACE",
        "SYSTEM"
      ].includes(spaceOrFolder.data.type)) {
        options.push({
          name: spaceOrFolder.name,
          subType: AssistantEphemeralContextSubType.Space,
          value: spaceOrFolder.id,
          type: AssistantEphemeralContextType.Ancestor
        });
      }
      if (spaceOrFolder.type === "folder") {
        options.push({
          name: spaceOrFolder.name,
          subType: AssistantEphemeralContextSubType.Folder,
          value: spaceOrFolder.id,
          type: AssistantEphemeralContextType.Ancestor
        });
      }
      if (spaceOrFolder.type === "space" && spaceOrFolder.data.type === "INTEGRATION") {
        options.push({
          name: spaceOrFolder.name,
          subType: AssistantEphemeralContextSubType.Connection,
          value: spaceOrFolder.id,
          type: AssistantEphemeralContextType.Ancestor
        });
      }
    }
    if (expandedResourceId || resourceId) {
      options.push({
        name: void 0,
        subType: AssistantEphemeralContextSubType.File,
        value: expandedResourceId ?? resourceId,
        type: AssistantEphemeralContextType.Resource
      });
    }
    return options;
  }, [
    spaceOrFolder,
    isInbox,
    inboxRoot,
    resourceId,
    expandedResourceId
  ]);
  return contextOptions;
};

export { useContextFinder };
//# sourceMappingURL=useContextFinder.js.map
